import { hotRanking } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function HotRanking() {
  const [top, ...rest] = hotRanking;

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            id="ranking"
            kicker="01 / RANKING"
            title="热度榜单"
            desc="按社区讨论量排序，把这段时间最受关注的争议事件排成一列。排名会随讨论热度推移变化，不代表任何立场。"
          />
          <div
            data-reveal
            className="flex flex-none items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-4 py-2 self-start md:self-auto"
          >
            <i className="ri-refresh-line text-sm text-accent-700" />
            <span className="text-xs text-accent-800">每小时更新</span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-5 md:mt-14">
          {/* 榜首大卡 */}
          <article
            data-reveal
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-2"
          >
            <div className="relative h-64 w-full overflow-hidden md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20radiating%20gold%20foil%20shards%20and%20concentric%20dark%20crimson%20rings%2C%20film%20grain%20texture%2C%20bold%20geometric%20collage%2C%20dramatic%20moody%20lighting%2C%20artistic%20poster%20composition%2C%20charcoal%20and%20warm%20amber%20palette%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=900&height=900&seq=hl-rank-01&orientation=squarish"
                alt="热度榜首档案封面"
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
              <div className="absolute left-5 top-5 flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-display text-lg text-accent-950">
                  1
                </span>
                <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-800 backdrop-blur">
                  榜首
                </span>
              </div>
            </div>

            <div className="p-6">
              <span className="inline-flex rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                {top.category}
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {top.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">{top.summary}</p>

              <div className="mt-6">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>讨论热度 {top.heat}</span>
                  <span>{top.stat}</span>
                </div>
                <div className="mt-2 h-2 w-full rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${top.heat}%` }}
                  />
                </div>
              </div>
            </div>
          </article>

          {/* 其余榜位 */}
          <div className="lg:col-span-3">
            <ul className="divide-y divide-background-200 border-y border-background-200">
              {rest.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#feed"
                    data-reveal
                    className="group flex items-start gap-5 py-5 cursor-pointer md:py-6"
                  >
                    <span className="font-display text-3xl leading-none text-foreground-300 transition-colors group-hover:text-primary-500 md:text-4xl">
                      {String(item.rank).padStart(2, '0')}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                          {item.title}
                        </h3>
                        <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-xs text-foreground-600">
                          {item.category}
                        </span>
                      </div>
                      <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
                        {item.summary}
                      </p>
                      <div className="mt-3 flex items-center gap-3">
                        <div className="h-1.5 w-32 rounded-full bg-background-200">
                          <div
                            className="h-full rounded-full bg-accent-500"
                            style={{ width: `${item.heat}%` }}
                          />
                        </div>
                        <span className="text-xs text-foreground-500">{item.stat}</span>
                      </div>
                    </div>
                    <i className="ri-arrow-right-up-line mt-1 text-lg text-foreground-300 transition-colors group-hover:text-primary-500" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}